import React, { useState, useEffect } from "react";
import Chat, { Bubble, useMessages, toast, Modal, Input, Icon } from "@chatui/core";
import {
  chatQuery,
  getConversationMessages,
  getToken,
  createWorkOrder,
  createResult,
  wbbUpload
} from "./api/api";
import remarkGfm from "remark-gfm";
import { PhotoProvider, PhotoView } from "react-photo-view";
import ReactMarkdown from "react-markdown";
import "react-photo-view/dist/react-photo-view.css";
import { isWorkingTime } from "./utils/holidayUtils";

let timeId = null
let endTimer = null
// 默认快捷短语，可选
const defaultQuickReplies = window.curProInfo.defaultQuickReplies;
const timeLong = window.curProInfo.interval_time * 1000;
const replyOpen = window.curProInfo.replyOpen;
const keyWords = window.curProInfo.keyWords;
const nokeyWords = window.curProInfo.noKyeWords;
const replyMsg = window.curProInfo.replyMsg;
const endSession = window.curProInfo.endSession * 1000;
const hoildayMsg = window.curProInfo.hoildayMsg;
const salutation = window.curProInfo.salutation;

// 初始消息（如果没有Base64数据，就显示“您好，我是信息中心智能客服。请问有什么可以帮您？”）
let initialMessages = [
  {
    type: "text",
    content: { text: salutation },
    position: "left",
    isRobot: true,
  },
];

// 将 Base64 字符串解码为 UTF-8 字符串
function base64ToUtf8(base64) {
  // 替换 URL 安全的 Base64 字符
  base64 = base64.replace(/-/g, '+').replace(/_/g, '/');
  // 填充 Base64 字符串
  while (base64.length % 4) {
    base64 += '=';
  }
  try {
    // 解码 Base64 字符串
    const binaryString = window.atob(base64);
    // 将二进制字符串转换为 UTF-8 字符串
    const bytes = new Uint8Array(binaryString.length);
    for (let i = 0; i < binaryString.length; i++) {
      bytes[i] = binaryString.charCodeAt(i);
    }
    return new TextDecoder().decode(bytes);
  } catch (error) {
    console.error("Base64 解码失败:", error);
    return null;
  }
}

// 从 URL 中解码 Base64 数据
function decodeBase64FromUrl() {
  const base64String = window.location.search.substring(1);

  if (!base64String) {
    console.error("未找到 base64 编码数据");
    return null;
  }

  try {
    // 对 URL 中的 Base64 字符串进行解码
    const decodedBase64String = decodeURIComponent(base64String);
    const decodedString = base64ToUtf8(decodedBase64String);
    if (!decodedString) {
      return null;
    }
    const keyValuePairs = decodedString.split("#");
    const result = {};

    keyValuePairs.forEach((pair) => {
      const [key, value] = pair.split("=");
      result[key] = value;
    });

    return result;
  } catch (error) {
    console.error("解码失败:", error);
    return null;
  }
}




export default function App() {
  // 在初始化 useMessages 之前解码数据，并根据结果修改 initialMessages
  const data = decodeBase64FromUrl();
  if (data && data.reportName) {
    initialMessages[0].content.text = `${data.reportName}，${salutation}`;
  }

  const [isModalVisible, setIsModalVisible] = useState(false);
  const [updatedData, setUpdatedData] = useState(data || {});
  const [workOrderData, setWorkOrderData] = useState("");
  const [titleMsg, setSendMsg] = useState("")
  const [botIsResponding, setBotIsResponding] = useState(false); // 新增状态，标记AI是否在回复
  const [showModal, setShowModal] = useState(false);//判断是否有新增会话ID,弹窗
  const [isWorking, setIsWorking] = useState(isWorkingTime());
  const [loading, setLoading] = useState(false);
  const [text, setText] = useState(false);
  const [textContent, setTextContent] = useState("");
  const [moreTimer, setMoreTimer] = useState(false)
  const [moreTimeVisible, setMoreTimeVisible] = useState(false)
  const [historysessionId, setHistorysessionId] = useState("")
  const [uploadedImages, setUploadedImages] = useState([]);
  // 使用 useMessages 钩子管理消息和输入状态
  const { messages, deleteMsg, appendMsg, setTyping, } = useMessages(initialMessages);

  useEffect(() => {
    const sessionID = localStorage.getItem("AppConversationID");
    clearTimeout(endTimer)
    clearTimeout(timeId)
    // 检查是否有未结束的会话
    if (sessionID) {
      setShowModal(true); // 如果会话ID存在，则显示Modal
    }
    setIsWorking(isWorkingTime())
  }, []);

  // 提交工单函数
  const initWorkOrderProcess = async (submitData, attachmentIds) => {
    try {
      const token = await getToken();
      let workData = {
        content: JSON.stringify(submitData),
        attachmentIds: attachmentIds.join(","),
      };
      let taskIdData = await createWorkOrder(workData, token);
      let taskId = taskIdData.data.taskId
      setIsModalVisible(false);
      let data = await createResult(taskId, token);
      setText(false)
      setLoading(true)
      let code = data.code;
      while (code === 1002) {
        // 等待一段时间，避免过于频繁地调用接口，可以根据实际情况调整时间
        await new Promise(resolve => setTimeout(resolve, 1000));
        data = await createResult(taskId, token);
        code = data.code;
      }
      if (code === 2000) {
        handleSend("text", titleMsg);
        setTextContent("您的报修已确认，我们会尽快回复您。")
      }
      if (code === 2001) {
        setTextContent(data.msg)
      }
      setText(true)
      clearTimeout(endTimer)
      clearTimeout(timeId)
      setHistorysessionId(localStorage.getItem("AppConversationID"))
      localStorage.removeItem("AppConversationID")
      setUploadedImages([])
      setMoreTimer(false)
      appendMsg(
        {
          type: 'system',
          content: {
            text: '当前会话已结束',
          },
        },
      );

    } catch (error) {
      setUploadedImages([])
      toast.show("工单提交失败，请稍后再试！");
    }
  };

  const handleEndSession = () => {
    endTimer = setTimeout(() => {
      appendMsg({
        type: "system",
        content: { text: "您长时间未操作，本次会话结束。" },
      });
      setHistorysessionId(localStorage.getItem("AppConversationID"))
      localStorage.removeItem("AppConversationID");
      setMoreTimer(true)
      clearTimeout(endTimer)
      clearTimeout(timeId)
    }, endSession);
  };

  // 快捷短语回调
  async function handleQuickReplyClick(item, flat) {
    const historyMessages = await getConversationMessages(100); // 获取历史消息
    let msg = historyMessages.filter(
      (hist) => hist.Query !== defaultQuickReplies[0].name
    );

    if (msg.length >= 1) {
      let chatContent = msg.map((hist) => {
        return {
          query: hist.Query,
          Answer: hist.AnswerInfo.Answer,
        };
      });
      if (flat) {
        setSendMsg(item.name);
      }
      setWorkOrderData(chatContent);
      setIsModalVisible(true);
      clearTimeout(endTimer)
      clearTimeout(timeId)
    } else {
      if (messages && messages.length > 1) {
        if (moreTimer) {

          setMoreTimeVisible(true)
          // toast.show("上次会话因超时结束，是否继续上次会话提交工单");
        } else {
          toast.show("上次会话已创建工单，如需再次创建工单，请重新描述您的问题");
        }
        clearTimeout(endTimer)
        clearTimeout(timeId)
      } else {
        toast.show("请先描述您的问题");
      }
    }
  }

  //继续提交上次会话的工单
  async function handleContinue() {
    historysessionId && localStorage.setItem("historysessionId", historysessionId)
    const historyMessages = await getConversationMessages(100, true); // 获取历史消息
    let msg = historyMessages.filter(
      (hist) => hist.Query !== defaultQuickReplies[0].name
    );

    if (msg.length >= 1) {
      let chatContent = msg.map((hist) => {
        return {
          query: hist.Query,
          Answer: hist.AnswerInfo.Answer,
        };
      });
      setMoreTimer(false)
      deleteMsg(messages[messages.length - 1]._id)
      setSendMsg(defaultQuickReplies[0].name)
      setMoreTimeVisible(false)
      setWorkOrderData(chatContent);
      setIsModalVisible(true);
      clearTimeout(endTimer)
      clearTimeout(timeId)
    }
  }

  // 定义发送消息的函数
  async function handleSend(type, val) {
    clearTimeout(endTimer)
    clearTimeout(timeId)
    // 若AI正在回复中，不允许发送消息
    if (botIsResponding) {
      toast.show("信息中心智能客服正在回复中，请等待回复完成后再试...");
      return;
    }
    let falt = false;
    if (defaultQuickReplies[0].name === val) {
      falt = true;
    }
    if (type === "text" && val.trim()) {
      appendMsg({
        type: "text",
        content: { text: val },
        position: "right",
      });

      setTyping(true);
      setBotIsResponding(true);
      try {
        await chatQuery(
          val,
          (response) => {
            setBotIsResponding(false);
            const formattedResponse = response.replace(
              /(!\[.*?\]\()(.+?)(\))/g,
              (match, p1, p2, p3) => `${p1}${encodeURI(p2)}${p3}`
            );
            setIsWorking(isWorkingTime())
            const containsKeyWord = keyWords.some(keyWord => formattedResponse.includes(keyWord));
            const containsNoKeyWord = nokeyWords.some(nokeyWord => formattedResponse.includes(nokeyWord));

            if (containsKeyWord && !containsNoKeyWord) {
              if (!isWorkingTime()) {
                appendMsg({
                  type: "text",
                  content: { text: hoildayMsg },
                  position: "left",
                  isRobot: true,
                });
              } else {
                handleQuickReplyClick(formattedResponse);
                appendMsg({
                  type: "text",
                  content: { text: formattedResponse },
                  position: "left",
                  isRobot: true,
                });
              }

            } else {
              appendMsg({
                type: "text",
                content: { text: formattedResponse },
                position: "left",
                isRobot: true,
              });
            }

            if (falt) {
              // appendMsg(
              //   {
              //     type: 'system',
              //     content: {
              //       text: '当前会话已结束',
              //     },
              //   },
              // );
            } else {
              clearTimeout(timeId)
              if (replyOpen) {
                timeId = setTimeout(() => {
                  appendMsg({
                    type: "text",
                    content: { text: replyMsg },
                    position: "left",
                    isRobot: true,
                  });
                }, timeLong);
                handleEndSession();
              }

            }
            setTyping(false);
          },
          (error) => {
            setBotIsResponding(false);
            appendMsg({
              type: "text",
              content: { text: "抱歉，系统开小差了，请稍后重试。" },
              position: "left",
              isRobot: true,
            });
            setTyping(false);
          }
        );
      } catch (error) {
        setBotIsResponding(false);
        appendMsg({
          type: "text",
          content: { text: "抱歉，系统开小差了，请稍后重试。" },
          position: "left",
          isRobot: true,
        });
        setTyping(false);
      }
    }
  }

  function renderMessageContent(msg) {
    const { type, content } = msg;
    switch (type) {
      case "text":
        return (
          <Bubble>
            <PhotoProvider>
              <ReactMarkdown
                remarkPlugins={[remarkGfm]}
                components={{
                  img: ({ node, ...props }) => (
                    <PhotoView src={props.src}>
                      <img
                        {...props}
                         alt="上传的图片"
                        style={{
                          maxWidth: "100%",
                          display: "block",
                          margin: "10px 0",
                          cursor: "pointer",
                        }}
                      />
                    </PhotoView>
                  ),
                  strong: ({ node, ...props }) => (
                    <strong>{props.children}</strong>
                  ),
                }}
              >
                {content.text}
              </ReactMarkdown>
            </PhotoProvider>
          </Bubble>
        );
      case "image":
        return (
          <Bubble type="image">
            <PhotoProvider>
              <PhotoView src={content.picUrl}>
                <img
                  src={content.picUrl}
                  alt="上传的图片"
                  style={{ maxWidth: "100%", cursor: "pointer" }}
                />
              </PhotoView>
            </PhotoProvider>
          </Bubble>
        );
      default:
        return <Bubble>抱歉，无法识别的消息类型。</Bubble>;
    }
  }

  // 处理输入框修改数据
  const handleInputChange = (value, field) => {
    setUpdatedData((prevData) => ({
      ...prevData,
      [field]: value,
    }));
  };

  // 检查必填项
  const validateRequiredFields = () => {
    // 必填字段列表，不包括备注
    const requiredFields = ["reportName", "reportUserNumber", "repairTel", "repairDepartmentName"];

    for (let field of requiredFields) {
      if (!updatedData[field] || updatedData[field].trim() === "") {
        return false;
      }
    }
    return true;
  };

  // 提交工单数据
  const handleSubmitWorkOrder = async () => {
    if (!validateRequiredFields()) {
      toast.show("请填写所有必填项后再提交！");
      return;
    }
    console.log("uploadedImages", uploadedImages);
    let submitData = {
      userInfo: updatedData,
      chatContent: workOrderData,
    };
    let attachmentIds = uploadedImages.map(item => item.attachmentId);
    await initWorkOrderProcess(submitData, attachmentIds);
    setIsModalVisible(false);
  };


  async function handleContinueSession() {
    setShowModal(false);
    // 加载上次会话的消息
    const historyMessages = await getConversationMessages(100); // 获取历史消息
    historyMessages && historyMessages.length && historyMessages.forEach((hist) => {
      appendMsg({
        type: "text",
        content: { text: hist.Query },
        position: "right",
      });
      const formattedResponse = hist.AnswerInfo.Answer
      const containsKeyWord = keyWords.some(keyWord => formattedResponse.includes(keyWord));
      const containsNoKeyWord = nokeyWords.some(nokeyWord => formattedResponse.includes(nokeyWord));

      if (containsKeyWord && !containsNoKeyWord) {
        if (!isWorkingTime(hist.AnswerInfo.CreatedTime * 1000)) {//  1736294682000
          appendMsg({
            type: "text",
            content: { text: hoildayMsg },
            position: "left",
            isRobot: true,
          });
        } else {
          appendMsg({
            type: "text",
            content: { text: hist.AnswerInfo.Answer },
            position: "left",
            isRobot: true,
          });
        }
      } else {
        appendMsg({
          type: "text",
          content: { text: hist.AnswerInfo.Answer },
          position: "left",
          isRobot: true,
        });
      }

    });
    handleEndSession();
  };

  const handleEnd = () => {
    setShowModal(false);
    // 结束当前会话并清除会话ID
    setHistorysessionId(localStorage.getItem("AppConversationID"))
    localStorage.removeItem("AppConversationID");
    // 进行一些其他操作，比如清空当前消息等
    // setMessages([]);
  };
  const handleRemoveImage = (index) => {
    setUploadedImages(prevImages => prevImages.filter((_, i) => i !== index));
  };

  return (
    <PhotoProvider>
      <Chat
        navbar={{ title: "信息中心智能客服" }}
        messages={messages}
        renderMessageContent={renderMessageContent}
        onSend={handleSend}
        quickReplies={defaultQuickReplies}
        quickRepliesVisible={isWorking}
        onQuickReplyClick={(item) => handleQuickReplyClick(item, true)}
        onInputFocus={() => {
          document.body.classList.remove("S--focusing");
        }}

        toolbar={[
          {
            type: 'image',
            icon: "image",
            title: '相册',
          }
        ]}
        onToolbarClick={(item) => {
          if (item.type === 'image') {
            const input = document.createElement('input');
            input.type = 'file';
            input.multiple = true;
            input.accept = 'image/*';
            input.addEventListener('change', async (event) => {
              const files = Array.from(event.target.files).slice(0, 5); // 最多选择五张图片
              const token = await getToken();
              for (const file of files) {
                const formData = new FormData();
                formData.append("file", file);
                try {
                  let res = await wbbUpload(token, formData);
                  const attachmentId = res.data.result.RESULT[0].ATTACHMENT_ID;
                  const reader = new FileReader();
                  reader.onload = (e) => {
                    setUploadedImages(prevImages => [...prevImages, {
                      name: file.name,
                      size: file.size,
                      type: file.type,
                      data: e.target.result,
                      attachmentId: attachmentId
                    }]);
                    appendMsg({
                      type: 'image',
                      content: { picUrl: e.target.result },
                      position: "right"
                    });
                  };
                  reader.readAsDataURL(file);
                } catch (error) {
                  console.error('读取图片时出错:', error);
                }
              }
            });
            input.click();
          }
        }}
      />

      {isWorking && <Modal
        active={isModalVisible}
        title="确认信息"
        showClose={false}
        onClose={() => {
          setIsModalVisible(false)
          handleEndSession();
        }}
        actions={[{
          label: "确定",
          color: "primary",
          onClick: handleSubmitWorkOrder,
        }]}
      >
        <div
          style={{
            fontSize: 16,
            fontWeight: 600,
            marginBottom: 4,
            marginTop: 10,
            marginLeft: 12,
          }}
        >
          报修人<span style={{ marginLeft: 4, color: "red" }}>*</span>
        </div>
        <Input
          value={updatedData.reportName || ""}
          onChange={(val) => handleInputChange(val, "reportName")}
          placeholder="请输入报修人姓名..."
        />

        <div
          style={{
            fontSize: 16,
            fontWeight: 600,
            marginBottom: 4,
            marginTop: 10,
            marginLeft: 12,
          }}
        >
          工号<span style={{ marginLeft: 4, color: "red" }}>*</span>
        </div>
        <Input
          value={updatedData.reportUserNumber || ""}
          onChange={(val) => handleInputChange(val, "reportUserNumber")}
          placeholder="请输入工号..."
        />

        <div
          style={{
            fontSize: 16,
            fontWeight: 600,
            marginBottom: 4,
            marginTop: 10,
            marginLeft: 12,
          }}
        >
          电话<span style={{ marginLeft: 4, color: "red" }}>*</span>
        </div>
        <Input
          value={updatedData.repairTel || ""}
          onChange={(val) => handleInputChange(val, "repairTel")}
          placeholder="请输入电话..."
        />

        <div
          style={{
            fontSize: 16,
            fontWeight: 600,
            marginBottom: 4,
            marginTop: 10,
            marginLeft: 12,
          }}
        >
          科室<span style={{ marginLeft: 4, color: "red" }}>*</span>
        </div>
        <Input
          value={updatedData.repairDepartmentName || ""}
          onChange={(val) => handleInputChange(val, "repairDepartmentName")}
          placeholder="请输入科室..."
        />

        {/* 新增备注字段（非必填） */}
        <div
          style={{
            fontSize: 16,
            fontWeight: 600,
            marginBottom: 4,
            marginTop: 10,
            marginLeft: 12,
          }}
        >
          报修地址
        </div>
        <Input
          value={updatedData.remark || ""}
          maxRows={3}
          maxLength={200}
          autoSize={true}
          onChange={(val) => handleInputChange(val, "remark")}
          placeholder="请输入报修地址..."
        />

        <div style={{ marginTop: 10 }}>
          <div style={{ fontSize: 16, fontWeight: 600, marginBottom: 4, marginLeft: 12 }}>
            报修图片
          </div>
          <div style={{ display: 'flex', flexWrap: 'wrap', gap: 10, marginLeft: 12 }}>
            {uploadedImages.map((image, index) => (
              <div key={index} style={{ position: 'relative' }}>
                <PhotoProvider>
                  <PhotoView src={image.data}>
                    <img
                      src={image.data}
                      alt={image.name}
                      style={{ width: 80, height: 80, objectFit: 'cover', borderRadius: 4 }}
                    />
                  </PhotoView>
                </PhotoProvider>
                <button
                  style={{
                    position: 'absolute',
                    top: 0,
                    right: 0,
                    backgroundColor: 'red',
                    color: 'white',
                    border: 'none',
                    borderRadius: '50%',
                    width: 20,
                    height: 20,
                    cursor: 'pointer',
                  }}
                  onClick={() => handleRemoveImage(index)}
                >
                  ×
                </button>
              </div>
            ))}
          </div>
          {/* 添加图片按钮 */}
          {uploadedImages.length < 5 && (
            <div style={{ marginTop: 10 }}>
              <div style={{ cursor: 'pointer' }} onClick={() => {
                const input = document.createElement('input');
                input.type = 'file';
                input.multiple = true;
                input.accept = 'image/*';
                input.addEventListener('change', async (event) => {
                  const files = Array.from(event.target.files).slice(0, 5 - uploadedImages.length); // 最多选择五张图片
                  const token = await getToken();
                  for (const file of files) {
                    const formData = new FormData();
                    formData.append("file", file);
                    try {
                      let res = await wbbUpload(token, formData);
                      const attachmentId = res.data.result.RESULT[0].ATTACHMENT_ID;
                      const reader = new FileReader();
                      reader.onload = (e) => {
                        setUploadedImages(prevImages => [...prevImages, {
                          name: file.name,
                          size: file.size,
                          type: file.type,
                          data: e.target.result,
                          attachmentId: attachmentId
                        }]);
                        appendMsg({
                          type: 'image',
                          content: { picUrl: e.target.result },
                          position: "right"
                        });
                      };
                      reader.readAsDataURL(file);
                    } catch (error) {
                      console.error('读取图片时出错:', error);
                    }
                  }
                });
                input.click();
              }}>
                <Icon style={{ width: 60, height: 40 }} type="plus-circle" />
              </div>
            </div>
          )}
        </div>
      </Modal>}

      {showModal && <Modal
        active={showModal}
        // onClose={() => setShowModal(false)}
        showClose={false}
        title={null}
      >
        <div style={{ display: "flex", justifyContent: "center", alignItems: "center", flexDirection: "column" }}>
          <p>上次会话未结束，是否继续上次会话？</p>
          <div style={{ display: "flex", justifyContent: "center", marginTop: 20 }}>
            <div style={{ width: 100, height: 40, textAlign: "center", lineHeight: "40px", backgroundColor: "#4a90e2", color: "#fff", borderRadius: 4 }} onClick={handleContinueSession}>继续</div>
            <div style={{ width: 100, height: 40, textAlign: "center", lineHeight: "40px", marginLeft: 40, backgroundColor: "#e5e7eb", borderRadius: 4 }} onClick={handleEnd}>结束</div>
          </div>
        </div>
      </Modal>}

      {moreTimer && moreTimeVisible && <Modal
        active={moreTimeVisible}
        // onClose={() => setShowModal(false)}
        showClose={false}
        title={null}
      >
        <div style={{ display: "flex", justifyContent: "center", alignItems: "center", flexDirection: "column" }}>
          <p>上次会话因超时结束，是否使用上次会话内容提交工单？</p>
          <div style={{ display: "flex", justifyContent: "center", marginTop: 20 }}>
            <div style={{ width: 100, height: 40, textAlign: "center", lineHeight: "40px", backgroundColor: "#4a90e2", color: "#fff", borderRadius: 4 }} onClick={handleContinue}>确认</div>
            <div style={{ width: 100, height: 40, textAlign: "center", lineHeight: "40px", marginLeft: 40, backgroundColor: "#e5e7eb", borderRadius: 4 }} onClick={() => { setMoreTimeVisible(false) }}>取消</div>
          </div>
        </div>
      </Modal>}

      {loading && <Modal
        active={true}
        // onClose={() => setShowModal(false)}
        showClose={false}
        title={text ? "提示" : null}
      >
        {!text ? <div style={{ display: "flex", justifyContent: "center", alignItems: "center", flexDirection: "column" }} >
          <div class="loader"></div>
          <div style={{ marginTop: 20 }}>创建中</div>
        </div> :
          <div>
            <div class="text">{textContent}</div>
            <div style={{ display: "flex", justifyContent: "center", marginTop: 20 }}>
              <div style={{ width: 100, height: 40, textAlign: "center", lineHeight: "40px", backgroundColor: "#e5e7eb", borderRadius: 4 }} onClick={() => {
                setLoading(false)
                setText(false)
              }}>关闭</div>
            </div>
          </div>}

      </Modal>}


    </PhotoProvider>
  );
}
